import React, { useState } from 'react';
import CustomModal from '../CustomModal/CustomModal';
import AppButton from '../../../../components/base/Tab/Button';
import './ConfirmationModal.scss';

interface ConfirmationModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: (reason?: string) => void;
  title: string;
  message?: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  isDangerPrimary?: boolean;
  isRequiredCloseIcon?: boolean;
  isReasonRequired?: boolean;
  isLoading?: boolean;
  customClassName?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onClose,
  onConfirm,
  title,
  message = '',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isDangerPrimary = false,
  isRequiredCloseIcon = true,
  isReasonRequired = false,
  isLoading = false,
  customClassName = '',
}) => {
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    if (isReasonRequired) {
      onConfirm(reason);
    } else {
      onConfirm();
    }
  };

  return (
    <CustomModal
      showModal={show}
      setShowModal={onClose}
      headerText={title}
      dialogClassName={`confirmation-modal ${customClassName}`}
      isCloseBtnRequired={isRequiredCloseIcon}
    >
      <div className="confirmation-modal-message">{message}</div>
      {isReasonRequired && (
        <textarea
          className="form-control mt-3"
          rows={3}
          placeholder="Enter reason..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
       />
      )}
      <div className="confirmation-modal-actions">
        <AppButton
          label={cancelText}
          onClick={onClose}
          variant="secondary"
          className="close-btn payment-modal-btn"
        />
        <AppButton
          label={confirmText}
          onClick={handleConfirm}
          className={`${isDangerPrimary ? 'btn-new-danger' : ''} payment-modal-btn`}
          disabled={isLoading}
        />
      </div>
    </CustomModal>
  );
};

export default ConfirmationModal;
